(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         *
         */
        .controller('chat2Ctrl', ['$scope', '$state', '$stateParams', '$filter', 'jwtService', 'comapiChatService', 'chatAdminService', 'conversations', 'permissionService', 'conversationProfileService', 'teamSettingsService', 'sharedDataService', 'teams', 'profileTemplate', 'comapiChatStore',
            function ($scope, $state, $stateParams, $filter, jwtService, comapiChatService, chatAdminService, conversations, permissionService, conversationProfileService, teamSettingsService, sharedDataService, teams, profileTemplate, comapiChatStore) {

                $scope.profileTemplate = profileTemplate.schema;
                $scope.needsConfiguring = false;

                $scope.currentState = function () {
                    return $state.current.name;
                }

                $scope.comapiChatStore = comapiChatStore;

                $scope.conversationStatuses = ['open', 'new', 'replied', 'closed'];
                $scope.teams = [{ name: "All" }];


                $scope.filterOptions = {
                    scope: $stateParams.scope || "profile",
                    conversationStatus: $stateParams.filter || $scope.conversationStatuses[0],  // 'open'
                    teamId: $stateParams.teamId || undefined
                };

                $scope.showNoConversations = function () {
                    var filteredConversations = $filter('chat2Filter')($scope.comapiChatStore.chats, $scope.filterOptions.conversationStatus, $scope.filterOptions.scope);
                    return filteredConversations.length === 0;
                }

                $scope.isAdmin = permissionService.checkPermission("chat:ra") === true;

                $scope.canStartChat = false;
                // make a list of all teams the user is a member of ...
                // user must be a member of at least 1 team that has configured channels ...
                var teamsUserIsMemberOf = [];

                var profileId = jwtService.payload.sub;

                angular.forEach(teams, function (team) {
                    $scope.teams.push(team);
                    angular.forEach(team.members, function (member) {
                        if (member.username === profileId) {
                            teamsUserIsMemberOf.push({ id: team.id });
                        }
                    });
                });

                teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId)

                    .then(function (config) {

                        angular.forEach(config.teams, function (team) {

                            var found = teamsUserIsMemberOf.find(function (t) {
                                return t.id === team.teamId;
                            })

                            if (found) {
                                found.channelCount = team.channels ? Object.keys(team.channels).length : 0;
                            }
                        });

                        angular.forEach(teamsUserIsMemberOf, function (team) {
                            if (team.channelCount > 0) {
                                $scope.canStartChat = true;
                            }
                        });
                    })
                    .catch(function (error) {
                        $scope.needsConfiguring = true;
                    });

                $scope.chatInView = function (conversation, $inview, $index) {
                    // synchronise conversations that have messages and have just come into view ...

                    if ($inview) {

                        if (conversation.continuationToken === undefined && conversation.latestRemoteEventId !== undefined) {
                            comapiChatService.synchronizeConversation(conversation.id);
                        }

                        conversationProfileService.applyProfileData(conversation);
                    }
                }

                $scope.getTeamName = function (teamId) {
                    var team = teams ? teams.find(function (t) {
                        return t.id === teamId;
                    }) : undefined;

                    return team ? team.name : teamId;
                }

                $scope.reload = function () {
                    // This is used to hide the conversation list  as it will update as we transition otherwise
                    // and the in-view functionality stops working and loads everything
                    $scope.reloading = true;

                    // This is used to hide the conversation list  as it will update as we transition otherwise
                    // and the in-view functionality stops working and loads everything
                    $scope.reloading = true;

                    var params = {
                        pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                        scope: $scope.filterOptions.scope,
                        filter: $scope.filterOptions.conversationStatus,
                        teamId: $scope.filterOptions.teamId
                    };

                    $state.go("main.apiSpace.chat2.chat", params, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });
                }

                $scope.setConversationStatus = function (status) {
                    $scope.filterOptions.conversationStatus = status;
                    $scope.reload();
                };

                $scope.setTeamFilter = function (team) {
                    $scope.filterOptions.teamId = team.id;
                    $scope.reload();
                }

                $scope.getTeamFilterName = function (teamId) {

                    if (teamId) {
                        var found = $scope.teams.find(function (t) { return t.id === teamId });
                        return found ? found.name : "All";
                    } else {
                        return "All";
                    }

                }

                $scope.formatLastMessage = function (conversation) {
                    var lastMessage = "";

                    if (conversation.lastMessage && conversation.lastMessage.parts) {
                        var part = conversation.lastMessage.parts[0];

                        var _type = part.type || "text/plain";
                        var split = _type.split('/');

                        var type = split[0];
                        var subType = split[1];

                        switch (type) {

                            case "text":
                                if (part.data) {
                                    lastMessage = "<span>" + part.data + "</span>";
                                } else {
                                    lastMessage = "<span>Attachment</span>";
                                }
                                break;

                            case "image":
                                lastMessage = "<span>Image</span>";
                                break;

                            case "comapi":
                                if (subType === "form") {
                                    lastMessage = "<span>Form</span>";
                                }
                                break;

                            default:
                                lastMessage = "<span>Attachment</span>";
                                break;

                        }
                    }

                    return lastMessage;
                }




                /**
                 * We are using this to display who the chat is allocated to ...
                 * If the conversation is closed, it won't be allocated to anyone ...
                 */
                $scope.getUsername = function (username) {
                    if (username) {

                        if (username.indexOf("PLATFORMUSER") === 0) {
                            return sharedDataService.getUsername(username.replace("\\", ":"));
                        } else {
                            return $scope.getTeamName(username);
                        }
                    }
                };

                $scope.startNewChat = function () {
                    chatAdminService.start($stateParams.pickedApiSpaceId);
                }



            }]);




})(window.angular);
